import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" fillRule="evenodd" d="M4 2a1 1 0 00-1 1v18a1 1 0 001 1h16a1 1 0 001-1V3a1 1 0 00-1-1H4zm8 5a6.1 6.1 0 00-6 5 6.1 6.1 0 0012 0 6.1 6.1 0 00-6-5zm1.96 6.96a2.77 2.77 0 11-3.92-3.92 2.77 2.77 0 113.92 3.92zm-3.14-.78a1.66 1.66 0 102.36-2.36 1.66 1.66 0 10-2.36 2.36z" clipRule="evenodd"/>
  </SvgIcon>
);